import React from "react";

const PlayIcon = () => {
    return (
        <div style={{borderRadius: '100%', border: '0.0625rem solid #fff', padding: '1.5rem'}}>
            <div style={{width: '1.25rem', height: '1.25rem', display: 'flex', justifyContent: 'center'}}>
                <svg fill='none'
                    viewBox='0 0 22 25'
                    xmlns='http://www.w3.org/2000/svg'>
                    <path d='M22 12.4998L0.587235 24.8624L0.587236 0.137119L22 12.4998Z'
                        fill='#fff'/>
                </svg>
            </div>
        </div>

    );
};

export default PlayIcon;
